var React = require('react');

function IconMenue (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon menue"},[React.createElement("line",{"id":"Line 1","x1":"1","y1":"7","x2":"27","y2":"7","stroke":"black","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"id":"Line 2","x1":"9","y1":"13","x2":"27","y2":"13","stroke":"black","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("line",{"id":"Line 2_2","x1":"9","y1":"1","x2":"27","y2":"1","stroke":"black","strokeWidth":"2","strokeLinecap":"round","key":2})]));
}

IconMenue.defaultProps = {"width":"28","height":"14","viewBox":"0 0 28 14","fill":"none"};

module.exports = IconMenue;

IconMenue.default = IconMenue;
